/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUserInfoCathView = /* GraphQL */ `
  mutation CreateUserInfoCathView(
    $input: CreateUserInfoCathViewInput!
    $condition: ModelUserInfoCathViewConditionInput
  ) {
    createUserInfoCathView(input: $input, condition: $condition) {
      UserEmailId
      Address
      Gender
      Hospitalname
      Mentorname
      AccessToken
      IDToken
      LastSignInDate
      UserAgreement
      LastSignOutDate
      Profession
      RefreshToken
      AccountCreatedOn
      AccountStatus
      Country
      UserAuthID
      UserName
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserInfoCathView = /* GraphQL */ `
  mutation UpdateUserInfoCathView(
    $input: UpdateUserInfoCathViewInput!
    $condition: ModelUserInfoCathViewConditionInput
  ) {
    updateUserInfoCathView(input: $input, condition: $condition) {
      UserEmailId
      Address
      Gender
      Hospitalname
      Mentorname
      AccessToken
      IDToken
      LastSignInDate
      UserAgreement
      LastSignOutDate
      Profession
      RefreshToken
      AccountCreatedOn
      AccountStatus
      Country
      UserAuthID
      UserName
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserInfoCathView = /* GraphQL */ `
  mutation DeleteUserInfoCathView(
    $input: DeleteUserInfoCathViewInput!
    $condition: ModelUserInfoCathViewConditionInput
  ) {
    deleteUserInfoCathView(input: $input, condition: $condition) {
      UserEmailId
      Address
      Gender
      Hospitalname
      Mentorname
      AccessToken
      IDToken
      LastSignInDate
      UserAgreement
      LastSignOutDate
      Profession
      RefreshToken
      AccountCreatedOn
      AccountStatus
      Country
      UserAuthID
      UserName
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCathViewUserReports = /* GraphQL */ `
  mutation CreateCathViewUserReports(
    $input: CreateCathViewUserReportsInput!
    $condition: ModelCathViewUserReportsConditionInput
  ) {
    createCathViewUserReports(input: $input, condition: $condition) {
      id
      userMailID
      userName
      reportCreatedDateTime
      issue_in
      report_title
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCathViewUserReports = /* GraphQL */ `
  mutation UpdateCathViewUserReports(
    $input: UpdateCathViewUserReportsInput!
    $condition: ModelCathViewUserReportsConditionInput
  ) {
    updateCathViewUserReports(input: $input, condition: $condition) {
      id
      userMailID
      userName
      reportCreatedDateTime
      issue_in
      report_title
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCathViewUserReports = /* GraphQL */ `
  mutation DeleteCathViewUserReports(
    $input: DeleteCathViewUserReportsInput!
    $condition: ModelCathViewUserReportsConditionInput
  ) {
    deleteCathViewUserReports(input: $input, condition: $condition) {
      id
      userMailID
      userName
      reportCreatedDateTime
      issue_in
      report_title
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
